/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { TasksApiConfiguration as __Configuration } from '../tasks-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ListQueryResultExpenseInfo } from '../models/list-query-result-expense-info';
import { CreateExpenseCommand } from '../models/create-expense-command';
import { UpdateExpenseCommand } from '../models/update-expense-command';
@Injectable({
  providedIn: 'root',
})
class ExpensesService extends __BaseService {
  static readonly GetAllPath = '/api/tasks/tasks/{id}/expenses';
  static readonly CreateExpensePath = '/api/tasks/tasks/{id}/expenses';
  static readonly GetExpenseForUpdatePath = '/api/tasks/tasks/{id}/expenses/{expenseId}/update';
  static readonly UpdateExpensePath = '/api/tasks/tasks/{id}/expenses/{expenseId}/update';
  static readonly DeleteExpensePath = '/api/tasks/tasks/{id}/expenses/{expenseId}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param id undefined
   * @return Success
   */
  GetAllResponse(id: string): __Observable<__StrictHttpResponse<ListQueryResultExpenseInfo>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/tasks/tasks/${id}/expenses`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ListQueryResultExpenseInfo>;
      })
    );
  }
  /**
   * @param id undefined
   * @return Success
   */
  GetAll(id: string): __Observable<ListQueryResultExpenseInfo> {
    return this.GetAllResponse(id).pipe(
      __map(_r => _r.body as ListQueryResultExpenseInfo)
    );
  }

  /**
   * @param params The `ExpensesService.CreateExpenseParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `command`:
   */
  CreateExpenseResponse(params: ExpensesService.CreateExpenseParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.command;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/tasks/tasks/${params.id}/expenses`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param params The `ExpensesService.CreateExpenseParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `command`:
   */
  CreateExpense(params: ExpensesService.CreateExpenseParams): __Observable<null> {
    return this.CreateExpenseResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param params The `ExpensesService.GetExpenseForUpdateParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `expenseId`:
   *
   * @return Success
   */
  GetExpenseForUpdateResponse(params: ExpensesService.GetExpenseForUpdateParams): __Observable<__StrictHttpResponse<UpdateExpenseCommand>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/tasks/tasks/${params.id}/expenses/${params.expenseId}/update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UpdateExpenseCommand>;
      })
    );
  }
  /**
   * @param params The `ExpensesService.GetExpenseForUpdateParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `expenseId`:
   *
   * @return Success
   */
  GetExpenseForUpdate(params: ExpensesService.GetExpenseForUpdateParams): __Observable<UpdateExpenseCommand> {
    return this.GetExpenseForUpdateResponse(params).pipe(
      __map(_r => _r.body as UpdateExpenseCommand)
    );
  }

  /**
   * @param params The `ExpensesService.UpdateExpenseParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `expenseId`:
   *
   * - `command`:
   */
  UpdateExpenseResponse(params: ExpensesService.UpdateExpenseParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    __body = params.command;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/tasks/tasks/${params.id}/expenses/${params.expenseId}/update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param params The `ExpensesService.UpdateExpenseParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `expenseId`:
   *
   * - `command`:
   */
  UpdateExpense(params: ExpensesService.UpdateExpenseParams): __Observable<null> {
    return this.UpdateExpenseResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param params The `ExpensesService.DeleteExpenseParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `expenseId`:
   */
  DeleteExpenseResponse(params: ExpensesService.DeleteExpenseParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/tasks/tasks/${params.id}/expenses/${params.expenseId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param params The `ExpensesService.DeleteExpenseParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `expenseId`:
   */
  DeleteExpense(params: ExpensesService.DeleteExpenseParams): __Observable<null> {
    return this.DeleteExpenseResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module ExpensesService {

  /**
   * Parameters for CreateExpense
   */
  export interface CreateExpenseParams {
    id: string;
    command?: CreateExpenseCommand;
  }

  /**
   * Parameters for GetExpenseForUpdate
   */
  export interface GetExpenseForUpdateParams {
    id: string;
    expenseId: string;
  }

  /**
   * Parameters for UpdateExpense
   */
  export interface UpdateExpenseParams {
    id: string;
    expenseId: string;
    command?: UpdateExpenseCommand;
  }

  /**
   * Parameters for DeleteExpense
   */
  export interface DeleteExpenseParams {
    id: string;
    expenseId: string;
  }
}

export { ExpensesService }
